const EXTENSION_TIMEOUT = 2000;

export default function setExtensionTimeOut(callback) {
  return setTimeout(callback, EXTENSION_TIMEOUT);
}
